(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["dasa-icons"] = {}, global.React));
})(this, function (exports, React) {
  'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);

    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function get() {
              return e[k];
            }
          });
        }
      });
    }

    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function SvgAdd(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 13h8v-2h-8V3h-2v8H3v2h8v8h2v-8z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1M = /*#__PURE__*/React__namespace.forwardRef(SvgAdd);

  function SvgAgConsulta(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 3.692a.692.692 0 00-1.385 0v1.154H5.203C4 4.846 3 5.804 3 7.016V18.83C3 20.042 4 21 5.203 21h3.89a.692.692 0 100-1.385h-3.89a.803.803 0 01-.818-.786v-7.983h15.23V13.1a.692.692 0 101.385 0V7.017c0-1.213-1-2.17-2.203-2.17h-2.412V3.691a.692.692 0 10-1.385 0v1.154H9V3.692zM5.203 6.231h2.412v.23a.692.692 0 001.385 0v-.23h6v.23a.692.692 0 001.385 0v-.23h2.412c.466 0 .818.366.818.786v2.445H4.385V7.017c0-.42.352-.786.818-.786zM12.063 21C11.2 21 11 20.817 11 19.94v-4.243c0-.877.2-1.06 1.063-1.06h4.25c1.361 0 1.562.183 1.562 1.59v3.712c0 .878-.2 1.061-1.063 1.061h-4.75zm8.033-.9a.606.606 0 00.477.034.624.624 0 00.362-.32.65.65 0 00.065-.283v-3.425c0-.17-.065-.33-.183-.45a.614.614 0 00-.722-.119l-1.422.724a.317.317 0 00-.168.23l-.005.001V19.144l.005.002a.317.317 0 00.168.23l1.423.724z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1L = /*#__PURE__*/React__namespace.forwardRef(SvgAgConsulta);

  function SvgAgExams(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.208h5v-4h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5v11h8v-5h-1v-2zm1.126 9H5a2 2 0 01-2-2v-13h4v-2h2v2h4v-2h2v2h4v6h3v2h-1v6a4 4 0 01-7.874 1zm5.874-7h-4v3h4v-3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1K = /*#__PURE__*/React__namespace.forwardRef(SvgAgExams);

  function SvgApp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 3H3v8h8V3zM5 9V5h4v4H5zm6 4H3v8h8v-8zm-6 6v-4h4v4H5zm8-6h8v8h-8v-8zm2 2v4h4v-4h-4zm6-12h-8v8h8V3zm-6 6V5h4v4h-4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1J = /*#__PURE__*/React__namespace.forwardRef(SvgApp);

  function SvgArrowCornerRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-corner-right_svg__clip0_23_8)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.657 16.25v-9.9a1 1 0 00-1-1h-9.9v2h7.486L4.929 17.664l1.414 1.414L16.657 8.765v7.485h2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-corner-right_svg__clip0_23_8"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1I = /*#__PURE__*/React__namespace.forwardRef(SvgArrowCornerRight);

  function SvgArrowDown(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-down_svg__clip0_2_3111)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.293 13.707l7 7a1 1 0 001.414 0l7-7-1.414-1.414L13 17.586V3h-2v14.586l-5.293-5.293-1.414 1.414z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-down_svg__clip0_2_3111"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1H = /*#__PURE__*/React__namespace.forwardRef(SvgArrowDown);

  function SvgArrowLeft(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.293 4.3l-7 7a1 1 0 000 1.414l7 7 1.414-1.414-5.293-5.293H21v-2H6.414l5.293-5.293L10.293 4.3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1G = /*#__PURE__*/React__namespace.forwardRef(SvgArrowLeft);

  function SvgArrowRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.707 19.714l7-7a1 1 0 000-1.414l-7-7-1.414 1.414 5.293 5.293H3v2h14.586L12.293 18.3l1.414 1.414z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1F = /*#__PURE__*/React__namespace.forwardRef(SvgArrowRight);

  function SvgArrowUp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-up_svg__clip0_2_3110)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.707 10.3l-7-7a1 1 0 00-1.414 0l-7 7 1.414 1.414L11 6.421v14.586h2V6.421l5.293 5.293 1.414-1.414z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-up_svg__clip0_2_3110"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1E = /*#__PURE__*/React__namespace.forwardRef(SvgArrowUp);

  function SvgAttachment(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.364 5.636a4.947 4.947 0 010 7l-6.682 6.683a3.6 3.6 0 01-5.091 0 3.599 3.599 0 010-5.092L12 8.818A2.25 2.25 0 0115.182 12l-4.773 4.773L9.136 15.5l4.83-4.83c.35-.35-.286-.987-.636-.636L7.863 15.5c-.7.7-.7 1.846 0 2.546.7.7 1.846.7 2.546 0l6.682-6.682a3.153 3.153 0 000-4.455 3.153 3.153 0 00-4.455 0l-6.045 6.045-1.273-1.272 6.046-6.046a4.947 4.947 0 017 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1D = /*#__PURE__*/React__namespace.forwardRef(SvgAttachment);

  function SvgAvatar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-5.284c1.72 0 3.486.693 5.297 2.158-1.8 1.205-3.565 1.808-5.297 1.808-1.732 0-3.505-.603-5.322-1.889 1.828-1.384 3.602-2.077 5.322-2.077zM12 5.4a4.725 4.725 0 110 9.45 4.725 4.725 0 010-9.45z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1C = /*#__PURE__*/React__namespace.forwardRef(SvgAvatar);

  function SvgBrowser(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.239 16.883h3.37a.744.744 0 01.748.748.753.753 0 01-.744.753H5.24a2.233 2.233 0 01-1.583-.66A2.258 2.258 0 013 16.134V5.25c0-.597.236-1.17.656-1.592.42-.422.99-.659 1.583-.659h13.434c.594 0 1.163.237 1.583.66.42.422.656.994.656 1.591v4.153a.752.752 0 01-.753.744.744.744 0 01-.74-.757V6.94a.188.188 0 00-.186-.188H4.679a.186.186 0 00-.186.189v9.192a.752.752 0 00.746.75zm5.228-12.66a.724.724 0 00-.265.278.736.736 0 00-.114.375.738.738 0 00.114.375.724.724 0 00.634.38.718.718 0 00.635-.38.732.732 0 00.115-.375.73.73 0 00-.115-.375.724.724 0 00-.635-.38.719.719 0 00-.369.102zm-2.612 0a.724.724 0 00-.265.278.736.736 0 00-.114.375.738.738 0 00.114.375.724.724 0 00.634.38.719.719 0 00.635-.38.732.732 0 00.115-.375.73.73 0 00-.115-.375.724.724 0 00-.635-.38.719.719 0 00-.369.102zm-2.648.024a.75.75 0 00-.275.322h.002a.744.744 0 00-.07.307.738.738 0 00.114.375.724.724 0 00.634.38.719.719 0 00.635-.38.732.732 0 00.114-.375.73.73 0 00-.114-.375.736.736 0 00-.635-.375.743.743 0 00-.405.12zm10.016 8.481l.887-.894a2.856 2.856 0 012.024-.854 2.842 2.842 0 012.029.84A2.874 2.874 0 0121 13.862a2.887 2.887 0 01-.85 2.035l-.887.893a.745.745 0 01-1.283-.528.755.755 0 01.228-.533l.887-.893a1.376 1.376 0 000-1.94 1.361 1.361 0 00-1.929 0l-.886.893a.747.747 0 01-.82.174.745.745 0 01-.464-.7.755.755 0 01.227-.534zm-.378 6.382l.938-.943a.744.744 0 011.265.534.753.753 0 01-.21.527l-.938.944a2.849 2.849 0 01-4.027-.014 2.88 2.88 0 01-.013-4.05l.938-.943a.744.744 0 011.264.534.753.753 0 01-.209.528l-.937.943a1.376 1.376 0 000 1.94 1.361 1.361 0 001.929 0zm2.926-4.883a.744.744 0 00-1.055 0l-2.638 2.656a.752.752 0 00.525 1.29.74.74 0 00.53-.229l2.638-2.652a.751.751 0 000-1.065z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1B = /*#__PURE__*/React__namespace.forwardRef(SvgBrowser);

  function SvgCake(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 12.21V9.207a2 2 0 00-2-2H5a2 2 0 00-2 2v12h18V12.21zm-2 2.854a3.36 3.36 0 01-1 .144c-1.319 0-2.29-.644-2.903-1.24-.621.661-1.615 1.24-3.097 1.24-1.487 0-2.482-.583-3.104-1.246-.61.592-1.584 1.246-2.896 1.246-.364 0-.697-.05-1-.147v4.147h14v-4.144zM5 12.187a1.512 1.512 0 00.02.155c.022.124.064.274.134.413a.794.794 0 00.261.31c.1.067.272.143.585.143.621 0 1.133-.313 1.533-.71a3.714 3.714 0 00.579-.75l.002-.004v.001l-.001.002v.002l1.855.216h.002v-.003l-.002-.004-.001-.005v-.002l.006.022c.01.026.026.072.053.131.055.12.147.283.29.446.26.298.742.658 1.684.658s1.424-.36 1.685-.658a1.864 1.864 0 00.342-.577l.007-.022v.002l-.002.005-.001.004v.002l.001.001 1.86-.204h.002l.021.037a3.557 3.557 0 00.542.703c.391.391.902.707 1.543.707.325 0 .502-.078.602-.144a.758.758 0 00.254-.303 1.464 1.464 0 00.143-.538l.001-.024V9.21H5v2.978zm10.894-.427c0-.002-.001-.003-.002-.003l.001.002.001.001zM17 5.208c-.068 0-.15-.007-.241-.02-1.369-.195-1.35-1.593-.583-2.743l.408-.613a.5.5 0 01.832 0l.408.613c.767 1.15.785 2.548-.583 2.743-.09.013-.173.02-.241.02zm-5.242-.02c.092.013.174.02.242.02s.15-.007.242-.02c1.367-.195 1.349-1.593.582-2.743l-.408-.613a.5.5 0 00-.832 0l-.408.613c-.767 1.15-.786 2.548.582 2.743zM7 5.208c-.068 0-.15-.007-.241-.02-1.369-.195-1.35-1.593-.583-2.743l.408-.613a.5.5 0 01.832 0l.408.613c.767 1.15.786 2.548-.583 2.743-.09.013-.173.02-.241.02z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1A = /*#__PURE__*/React__namespace.forwardRef(SvgCake);

  function SvgCalendar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 5.372h2v.973c0 .537.448.972 1 .972s1-.435 1-.972v-.973h6v.973c0 .537.448.972 1 .972s1-.435 1-.972v-.973h2v12.645H5V5.372zm12-1.945h4v14.59c0 1.074-.895 1.945-2 1.945H5c-1.105 0-2-.87-2-1.945V3.427h4V1.48h2v1.946h6V1.48h2v1.946zm-8 7.781V9.263H7v1.945h2zm0 1.945V15.1H7v-1.946h2zm4 1.946v-1.946h-2V15.1h2zm4-1.946V15.1h-2v-1.946h2zm0-1.945V9.263h-2v1.945h2zm-4-1.945v1.945h-2V9.263h2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1z = /*#__PURE__*/React__namespace.forwardRef(SvgCalendar);

  function SvgCamera(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.908 8H4v10h16V8h-4.658l-.597-.683L13.593 6h-2.935L9.505 7.317 8.908 8zm7.342-2l-1.451-1.659A1 1 0 0014.046 4h-3.842a1 1 0 00-.753.341L8 6H3a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1h-4.75zM12 15a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zm6-8a1 1 0 100 2 1 1 0 000-2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1y = /*#__PURE__*/React__namespace.forwardRef(SvgCamera);

  function SvgCameraOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.182 14.982c.01.025.026.048.046.067l5.528 5.529a.833.833 0 01-1.178 1.178L2.244 3.423a.833.833 0 011.179-1.179l4.903 4.904a.207.207 0 00.147.06h6.444a1.25 1.25 0 011.25 1.25v6.444c0 .027.005.054.015.08zM4.638 7.36a.21.21 0 00-.233-.043 1.25 1.25 0 00-.738 1.141v7.5a1.25 1.25 0 001.25 1.25h9.066a.208.208 0 00.147-.355L4.638 7.36zm15.476.85l-2.5 1.425A1.205 1.205 0 0017 10.677v3.063a1.208 1.208 0 00.614 1.042l2.5 1.425A1.25 1.25 0 0022 15.168V9.25a1.25 1.25 0 00-1.886-1.04z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1x = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOff);

  function SvgCameraOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.44 10.978L20 9.756v4.1L17.311 13l-.622 1.85 4 1.273L22 15.198V8.195l-1.44-.873-4 1.91.88 1.746zM3 6.347c-.552 0-1 .435-1 .972v8.754c0 .538.448.973 1 .973h13v-10.7H3zM4 15.1V8.29h10v6.81H4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1w = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOn);

  function SvgCameraSwitch(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.015 1.334a.5.5 0 01-.406.58l-2.367.416A11 11 0 0112 23a.5.5 0 110-1 10 10 0 004.774-18.786l1.186 2.02a.5.5 0 11-.862.506l-1.966-3.349a.5.5 0 01.343-.766l3.96-.696a.5.5 0 01.58.405zM5.565 4.346A10 10 0 0112 2a.5.5 0 000-1 11 11 0 00-5.243 20.67l-2.366.416a.5.5 0 00.173.985l3.947-.694a.5.5 0 00.361-.761l-1.97-3.356a.5.5 0 10-.862.506l1.186 2.021A10.001 10.001 0 015.565 4.346zM13.882 7a1.5 1.5 0 011.34.829l.086.171H17.5A1.5 1.5 0 0119 9.5v6a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 016 15.5v-6A1.5 1.5 0 017.5 8h2.19l.086-.17A1.5 1.5 0 0111.117 7h2.764zm-3.15 3.732a2.5 2.5 0 113.536 3.536 2.5 2.5 0 01-3.536-3.536zM12.5 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1v = /*#__PURE__*/React__namespace.forwardRef(SvgCameraSwitch);

  function SvgCar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.78 12H8c-1.328 0-2.168.33-2.713.738-.548.411-.886.97-1.088 1.578A5.58 5.58 0 003.938 16H5.17a3.001 3.001 0 015.658 0h2.342a3.001 3.001 0 015.658 0H20v-1c0-1.127-.13-2.125-.36-3H8.78zm.764-2h9.293C17.657 7.94 15.762 7 14 7c-1.378 0-2.55.72-3.46 1.686-.41.436-.743.896-.996 1.314zM3 18h2.17a3.001 3.001 0 005.66 0h2.34a3.001 3.001 0 005.66 0H21a1 1 0 001-1v-2c0-6.423-3.826-10-8-10-2.122 0-3.784 1.113-4.915 2.314-.84.891-1.456 1.902-1.802 2.713-1.328.104-2.381.5-3.196 1.11-.95.714-1.488 1.655-1.786 2.547-.295.885-.364 1.75-.364 2.379a8.236 8.236 0 00.071 1.069l.004.02v.008l.001.002v.001L3 17l-.986.164A1 1 0 003 18zm13 0a1 1 0 100-2 1 1 0 000 2zm-7-1a1 1 0 10-2 0 1 1 0 002 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1u = /*#__PURE__*/React__namespace.forwardRef(SvgCar);

  function SvgCheck(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.774 7.726l-6.964 9.847a1 1 0 01-1.455.2L5.382 13.63a1.09 1.09 0 01-.159-1.49.99.99 0 011.43-.166l4.148 3.457 6.335-8.959c.208-.325.57-.504.943-.467.373.037.696.284.841.644.146.36.09.774-.146 1.077z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1t = /*#__PURE__*/React__namespace.forwardRef(SvgCheck);

  function SvgCheckRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-5.3-1.287l.714-.7-1.401-1.427-.714.7-4.39 4.312-2.208-2.169-.714-.7-1.401 1.427.713.7 2.91 2.857.7.689.701-.689 5.09-5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1s = /*#__PURE__*/React__namespace.forwardRef(SvgCheckRound);

  function SvgCheckboxEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2zM6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1r = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxEmpty);

  function SvgCheckboxIndeterminate(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2zM2 6a4 4 0 014-4h12a4 4 0 014 4v12a4 4 0 01-4 4H6a4 4 0 01-4-4V6zm5 5a1 1 0 100 2h10a1 1 0 100-2H7z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1q = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxIndeterminate);

  function SvgCheckboxSelected(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6zm5.81 15.573l6.964-9.847c.235-.303.292-.717.146-1.077a1.022 1.022 0 00-.841-.644 1.003 1.003 0 00-.943.467L10.8 15.431l-4.147-3.457a.99.99 0 00-1.43.165 1.09 1.09 0 00.158 1.49l4.973 4.144a1 1 0 001.455-.2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1p = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxSelected);

  function SvgChevronDown(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down_svg__clip0_2_3025)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.293 16.707l-8-8 1.414-1.414L12 14.586l7.293-7.293 1.414 1.414-8 8a1 1 0 01-1.414 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down_svg__clip0_2_3025"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1o = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDown);

  function SvgChevronDownSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down-sm_svg__clip0_131_22)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.986 15.76a1.151 1.151 0 01-.865-.39L6.216 9.794a.923.923 0 011.386-1.22l4.29 4.877a.125.125 0 00.188 0l4.29-4.876a.923.923 0 111.386 1.22l-4.904 5.573a1.155 1.155 0 01-.866.392z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down-sm_svg__clip0_131_22"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1n = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDownSm);

  function SvgChevronLeft(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.293 11.293l8-8 1.414 1.414L9.414 12l7.293 7.293-1.414 1.414-8-8a1 1 0 010-1.414z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1m = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeft);

  function SvgChevronLeftSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.24 11.986a1.15 1.15 0 01.39-.865l5.576-4.905a.924.924 0 011.22 1.386l-4.877 4.29a.125.125 0 000 .188l4.876 4.29a.923.923 0 11-1.22 1.386l-5.573-4.904a1.155 1.155 0 01-.392-.866z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1l = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeftSm);

  function SvgChevronRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.707 12.707l-8 8-1.414-1.414L14.586 12 7.293 4.707l1.414-1.414 8 8a1 1 0 010 1.414z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1k = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRight);

  function SvgChevronRightSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15.76 11.986a1.151 1.151 0 00-.39-.865L9.794 6.216a.923.923 0 00-1.22 1.386l4.877 4.29a.125.125 0 010 .188l-4.876 4.29a.924.924 0 101.22 1.386l5.573-4.904a1.153 1.153 0 00.392-.866z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1j = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRightSm);

  function SvgChevronUp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up_svg__clip0_2_3023)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.707 7.293l8 8-1.414 1.414L12 9.414l-7.293 7.293-1.414-1.414 8-8a1 1 0 011.414 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up_svg__clip0_2_3023"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1i = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUp);

  function SvgChevronUpSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up-sm_svg__clip0_131_25)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.014 8.24a1.15 1.15 0 01.865.39l4.905 5.576a.924.924 0 01-1.386 1.22l-4.29-4.877a.125.125 0 00-.188 0l-4.29 4.876a.923.923 0 11-1.386-1.22l4.904-5.573a1.156 1.156 0 01.866-.392z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up-sm_svg__clip0_131_25"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1h = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUpSm);

  function SvgClinic(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#clinic_svg__clip0_1297_7080)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.707 1.293a1 1 0 00-1.414 0l-10 10 1.414 1.414L4 11.414V20a2 2 0 002 2h12a2 2 0 002-2v-8.586l1.293 1.293 1.414-1.414-10-10zM18 9.414l-6-6-6 6V20h12V9.414zM11 10v3H8v2h3v3h2v-3h3v-2h-3v-3h-2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "clinic_svg__clip0_1297_7080"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1g = /*#__PURE__*/React__namespace.forwardRef(SvgClinic);

  function SvgClock(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM11 7v6h6v-2h-4V7h-2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1f = /*#__PURE__*/React__namespace.forwardRef(SvgClock);

  function SvgClose(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.586L5.636 4.222 4.222 5.636 10.586 12l-6.364 6.364 1.414 1.414L12 13.414l6.364 6.364 1.414-1.414L13.414 12l6.364-6.364-1.414-1.414L12 10.586z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1e = /*#__PURE__*/React__namespace.forwardRef(SvgClose);

  function SvgCloseRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM7.05 8.11a.75.75 0 011.06-1.06L12 10.939l3.889-3.89a.75.75 0 111.06 1.061L13.06 12l3.89 3.889a.75.75 0 01-1.061 1.06l-3.89-3.889-3.889 3.89a.75.75 0 11-1.06-1.061l3.889-3.89-3.89-3.889z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1d = /*#__PURE__*/React__namespace.forwardRef(SvgCloseRound);

  function SvgCross(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 21.208a2 2 0 01-2-2v-4H5a2 2 0 01-2-2v-2a2 2 0 012-2h4v-4a2 2 0 012-2h2a2 2 0 012 2v4h4a2 2 0 012 2v2a2 2 0 01-2 2h-4v4a2 2 0 01-2 2h-2zm0-8H5v-2h6v-6h2v6h6v2h-6v6h-2v-6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1c = /*#__PURE__*/React__namespace.forwardRef(SvgCross);

  function SvgDash(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1b = /*#__PURE__*/React__namespace.forwardRef(SvgDash);

  function SvgDoctor(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 13.005v6h8v-6h-8zm-2 7V13h-.21A3.79 3.79 0 005 16.79H3A5.79 5.79 0 018.79 11h1.594v.005H20a1 1 0 011 1v8a1 1 0 01-1 1H10a1 1 0 01-1-1zM10 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm2 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm1 10.255h1.25v1.25h1.5v-1.25H17v-1.5h-1.25v-1.25h-1.5v1.25H13v1.5zm1-5.75c0-.66.09-.907.13-.98a.98.98 0 01.154-.02c.124-.008.236-.006.385-.003a17.884 17.884 0 00.661 0c.15-.003.262-.005.386.003a.98.98 0 01.155.02c.039.073.129.32.129.98h2c0-1.146-.214-2.155-1.06-2.679-.386-.238-.793-.298-1.1-.317-.201-.013-.446-.009-.643-.006a13.924 13.924 0 01-.394 0c-.197-.003-.442-.007-.644.006-.306.02-.714.079-1.1.317C12.215 8.85 12 9.86 12 11.006h2zm.147-1.007l-.006.007.006-.007zm1.706 0l.006.007-.006-.007z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1a = /*#__PURE__*/React__namespace.forwardRef(SvgDoctor);

  function SvgDownload(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 19a2 2 0 002 2h14a2 2 0 002-2v-3h-2v3H5v-3H3v3zm8.293-2.293l-5-5 1.414-1.414L11 13.586V3h2v10.586l3.293-3.293 1.414 1.414-5 5a1 1 0 01-1.414 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$19 = /*#__PURE__*/React__namespace.forwardRef(SvgDownload);

  function SvgDownloadExam(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.646 2.784A.481.481 0 014 2.625h8.857c.133 0 .26.057.354.159l2.393 2.592c.093.102.146.24.146.383v2.147c0 .449.336.813.75.813s.75-.364.75-.813V5.758c0-.574-.21-1.125-.585-1.53L14.27 1.633A1.925 1.925 0 0012.857 1H4c-.53 0-1.04.228-1.414.635A2.262 2.262 0 002 3.167v14.896c0 .574.21 1.125.586 1.532.375.406.884.634 1.414.634h4.375c.414 0 .75-.364.75-.812 0-.45-.336-.813-.75-.813H4a.481.481 0 01-.354-.159.565.565 0 01-.146-.383V3.168c0-.144.053-.282.146-.383zM5.25 6.417c-.414 0-.75.363-.75.812 0 .449.336.813.75.813H14c.414 0 .75-.364.75-.813 0-.449-.336-.812-.75-.812H5.25zm0 4.062c-.414 0-.75.364-.75.813 0 .448.336.812.75.812h5c.414 0 .75-.364.75-.812 0-.449-.336-.813-.75-.813h-5zm-.75 4.875c0-.448.336-.812.75-.812h3.125c.414 0 .75.364.75.812 0 .449-.336.813-.75.813H5.25c-.414 0-.75-.364-.75-.813zM17.25 14c0-.449-.336-.813-.75-.813s-.75.364-.75.813v3.455l-.595-.644a.71.71 0 00-1.06 0 .861.861 0 000 1.149l1.875 2.031a.743.743 0 00.478.236.702.702 0 00.318-.05c.096-.04.185-.1.263-.184l.001-.002 1.875-2.031a.861.861 0 000-1.15.71.71 0 00-1.06 0l-.595.645V14zm-.75-1.896c-2.347 0-4.25 2.062-4.25 4.604 0 2.543 1.903 4.605 4.25 4.605s4.25-2.062 4.25-4.605c0-2.542-1.903-4.604-4.25-4.604zm-5.75 4.604c0-3.44 2.574-6.229 5.75-6.229s5.75 2.79 5.75 6.23c0 3.44-2.574 6.229-5.75 6.229s-5.75-2.79-5.75-6.23z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$18 = /*#__PURE__*/React__namespace.forwardRef(SvgDownloadExam);

  function SvgEdit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 13v-1.172l6-6L18.172 7l-6 6H11zm-2-2l6.586-6.586L17 3l1.414 1.414 1.172 1.172L21 7l-1.414 1.414L13 15H9v-4zM5 5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-2v6H5V7h6V5H5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$17 = /*#__PURE__*/React__namespace.forwardRef(SvgEdit);

  function SvgEvolution(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.376 2.5a1.624 1.624 0 00-1.589 1.964L15.51 6.245a1.625 1.625 0 00-2.2.533l-2.872-.768a1.624 1.624 0 10-3.203.237l-2.75 2.747a1.624 1.624 0 10.815.461l2.397-2.394a1.624 1.624 0 002.422-.202l2.941.786a1.624 1.624 0 103.07-.74l2.094-1.636.004.005A1.624 1.624 0 1019.376 2.5zM10.38 9.54a.842.842 0 00-.842.841v9.716H7.51V17.42a.842.842 0 00-.841-.842H4.516a.842.842 0 00-.842.842v2.677h-.722a.451.451 0 000 .902H19.962a.451.451 0 100-.902h-.722V13.9a.842.842 0 00-.842-.843h-2.993v7.039h-2.03V10.38a.842.842 0 00-.842-.842h-2.151z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$16 = /*#__PURE__*/React__namespace.forwardRef(SvgEvolution);

  function SvgExameImagem(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.916 10.569c0-4.74 3.747-8.685 8.5-8.685s8.5 3.946 8.5 8.685v.002c0 3.184-1.693 6.01-4.246 7.52l.327 3.511-1.486 1.53a1.31 1.31 0 01-.426.294 1.226 1.226 0 01-.963 0 1.312 1.312 0 01-.425-.294 1.423 1.423 0 01-.298-.461 1.501 1.501 0 010-1.12c.07-.177.173-.333.298-.462l2.834-2.916a8.313 8.313 0 01-4.115 1.08 8.36 8.36 0 01-6.055-2.588 8.78 8.78 0 01-2.445-6.096zm1.616.75H7.9c.093.445.268.865.509 1.239L5.997 15.04a7.269 7.269 0 01-1.465-3.721zm3.368-1.5c.093-.445.268-.865.509-1.238L5.997 6.099a7.269 7.269 0 00-1.465 3.72H7.9zm2.726-2.799c-.409.092-.788.254-1.127.47L7.063 4.986a6.79 6.79 0 013.563-1.554v3.59zM9.5 13.647l-2.435 2.507a6.79 6.79 0 003.562 1.553v-3.59a3.517 3.517 0 01-1.127-.47zm2.706.47v3.59a6.79 6.79 0 003.563-1.553l-2.436-2.507a3.517 3.517 0 01-1.127.47zM18.3 11.32a7.268 7.268 0 01-1.466 3.721l-2.412-2.482c.242-.374.416-.793.51-1.24H18.3zm-3.368-1.5H18.3a7.269 7.269 0 00-1.465-3.72L14.423 8.58c.241.374.415.793.509 1.239zM12.205 3.43a6.79 6.79 0 013.563 1.553l-2.435 2.507a3.515 3.515 0 00-1.128-.47V3.43zm-.79 5.002a1.972 1.972 0 011.42.622c.363.378.595.905.595 1.514 0 1.237-.96 2.135-2.014 2.135-1.054 0-2.014-.898-2.014-2.135 0-1.237.96-2.135 2.013-2.136z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$15 = /*#__PURE__*/React__namespace.forwardRef(SvgExameImagem);

  function SvgExams(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.252 19.97c-1.58 1.239-3.562 1.757-5.252 1.757s-3.672-.518-5.252-1.757C5.134 18.705 4 16.734 4 13.99c0-1.442.51-2.885 1.205-4.195.7-1.319 1.62-2.567 2.522-3.635a33.49 33.49 0 013.62-3.65l.001-.002h1.303l.002.001.087.074a30.874 30.874 0 011.053.956 33.5 33.5 0 012.48 2.621c.902 1.068 1.823 2.316 2.522 3.635C19.49 11.105 20 12.548 20 13.99c0 2.744-1.134 4.715-2.748 5.98zm-4.6-17.462a1.022 1.022 0 00-1.303 0h1.302zM12 4.56a31.537 31.537 0 00-2.727 2.834c-.848 1.004-1.677 2.135-2.29 3.292C6.364 11.85 6 12.977 6 13.99c0 2.164.866 3.575 2.003 4.465 1.169.917 2.687 1.326 3.997 1.326s2.828-.41 3.998-1.326C17.134 17.565 18 16.154 18 13.99c0-1.013-.365-2.14-.982-3.303-.614-1.157-1.443-2.288-2.29-3.292A31.511 31.511 0 0012 4.56z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$14 = /*#__PURE__*/React__namespace.forwardRef(SvgExams);

  function SvgExit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.586 13l-1.292 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L18.586 11H10v2h8.586zM3 5a2 2 0 012-2h10a2 2 0 012 2v3h-2V5H5v14h10v-3h2v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$13 = /*#__PURE__*/React__namespace.forwardRef(SvgExit);

  function SvgExpand(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$12 = /*#__PURE__*/React__namespace.forwardRef(SvgExpand);

  function SvgFamily(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.445 17.914C13.017 16.374 14.1 15 16 15c1.523 0 2.49.856 3.128 1.99.659 1.17.872 2.5.872 3.01h2c0-.823-.287-2.494-1.128-3.99C20.009 14.477 18.477 13 16 13c-2.559 0-4.08 1.547-4.937 3.134A4.65 4.65 0 008 15c-1.705 0-2.971.863-3.78 1.875C3.434 17.855 3 19.07 3 20h2c0-.404.232-1.189.781-1.875C6.305 17.47 7.039 17 8.001 17c.96 0 1.694.47 2.218 1.125.55.686.781 1.471.781 1.875h2c0-.62-.193-1.367-.555-2.086zM8 12a1 1 0 100-2 1 1 0 000 2zm0 2a3 3 0 100-6 3 3 0 000 6zm10-6a2 2 0 11-4 0 2 2 0 014 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$11 = /*#__PURE__*/React__namespace.forwardRef(SvgFamily);

  function SvgFavoriteEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.323 10.643L12 7.775l-1.323 2.868-3.136.371L9.86 13.16l-.616 3.097L12 14.713l2.756 1.543-.616-3.098 2.319-2.144-3.136-.371zm6.3-1.267a.64.64 0 01.358 1.105l-3.661 3.386.972 4.891a.64.64 0 01-.94.683L12 17.006 7.648 19.44a.64.64 0 01-.94-.683l.972-4.891-3.661-3.386a.64.64 0 01.359-1.105l4.952-.588L11.42 4.26a.64.64 0 011.162 0l2.089 4.528 4.952.588z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$10 = /*#__PURE__*/React__namespace.forwardRef(SvgFavoriteEmpty);

  function SvgFavoriteFilled(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.419 4.26a.64.64 0 011.162 0l2.089 4.528 4.952.588a.64.64 0 01.36 1.105l-3.662 3.386.972 4.891a.64.64 0 01-.94.683L12 17.006 7.648 19.44a.64.64 0 01-.94-.683l.972-4.891-3.661-3.386a.64.64 0 01.359-1.105l4.952-.588L11.42 4.26z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$$ = /*#__PURE__*/React__namespace.forwardRef(SvgFavoriteFilled);

  function SvgFilter(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#filter_svg__clip0_1341_6776)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.293 7.25h-18v-2.5h18v2.5zm-2 6h-14v-2.5h14v2.5zm-11 6h8v-2.5h-8v2.5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "filter_svg__clip0_1341_6776"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(.293)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$_ = /*#__PURE__*/React__namespace.forwardRef(SvgFilter);

  function SvgFold(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#fold_svg__clip0_8_1227)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.998 3.291a1 1 0 01.295.709v13a1 1 0 01-1 1h-3v3a1 1 0 01-1.351.936l-8.649-3.243V3.059L18.288 3a1 1 0 01.71.291zM15.293 16h2V5.005l-5.55.025 2.901 1.088a1 1 0 01.649.936V16zm-8-10.503v11.81l6 2.25V7.747l-6-2.25z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "fold_svg__clip0_8_1227"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(.293)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$Z = /*#__PURE__*/React__namespace.forwardRef(SvgFold);

  function SvgFullscreen(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#fullscreen_svg__clip0_1347_7087)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.293 14h-2v5h5v-2h-3v-3zm-2-4h2V7h3V5h-5v5zm12 7h-3v2h5v-5h-2v3zm-3-12v2h3v3h2V5h-5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "fullscreen_svg__clip0_1347_7087"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(.293)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$Y = /*#__PURE__*/React__namespace.forwardRef(SvgFullscreen);

  function SvgFullscreenExit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#fullscreen-exit_svg__clip0_1347_7099)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.293 16h3v3h2v-5h-5v2zm3-8h-3v2h5V5h-2v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "fullscreen-exit_svg__clip0_1347_7099"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(.293)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$X = /*#__PURE__*/React__namespace.forwardRef(SvgFullscreenExit);

  function SvgGenderFemale(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 9A5 5 0 117 9a5 5 0 0110 0zm-4 6.93A7.002 7.002 0 0012 2a7 7 0 00-1 13.93v1.514H8v2h3V22h2v-2.556h3v-2h-3V15.93z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$W = /*#__PURE__*/React__namespace.forwardRef(SvgGenderFemale);

  function SvgGenderMale(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.071 7.343v1.829h2V3.929h-5.243v2h1.829l-4.009 4.008a6.002 6.002 0 00-7.72 9.134 6 6 0 009.135-7.72l4.008-4.008zM12 12a4 4 0 10-5.657 5.657A4 4 0 0012 12z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$V = /*#__PURE__*/React__namespace.forwardRef(SvgGenderMale);

  function SvgGlasses(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 13h-1.126a4.002 4.002 0 01-7.845-.518 3.663 3.663 0 00-.209-.15C12.495 12.115 12.2 12 12 12c-.2 0-.495.115-.82.332-.077.05-.147.102-.209.15A4 4 0 013.126 13H2v-2h1.126a4.002 4.002 0 017.514-.66c.384-.185.853-.34 1.36-.34.508 0 .976.155 1.36.34a4 4 0 017.514.66H22v2zm-5 1a2 2 0 100-4 2 2 0 000 4zM7 14a2 2 0 100-4 2 2 0 000 4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$U = /*#__PURE__*/React__namespace.forwardRef(SvgGlasses);

  function SvgGridCol(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.875 21.454C2.841 21.454 2 20.636 2 19.63V3.824C2 2.818 2.84 2 3.875 2h1.25C6.159 2 7 2.818 7 3.824V19.63c0 1.006-.84 1.824-1.875 1.824h-1.25zm0-18.238a.617.617 0 00-.625.608V19.63c0 .335.28.608.625.608h1.25a.617.617 0 00.625-.608V3.824a.617.617 0 00-.625-.608h-1.25zm7.5 18.238c-1.033 0-1.874-.818-1.874-1.824V3.824C9.5 2.818 10.34 2 11.376 2h1.25c1.034 0 1.875.818 1.875 1.824V19.63c0 1.006-.841 1.824-1.875 1.824h-1.25zm0-18.238a.617.617 0 00-.624.608V19.63c0 .336.28.608.625.608h1.25a.617.617 0 00.625-.608V3.824a.617.617 0 00-.625-.608h-1.25zM17 19.63c0 1.006.84 1.824 1.875 1.824h1.25c1.034 0 1.875-.818 1.875-1.824V3.824C22 2.818 21.16 2 20.125 2h-1.25C17.841 2 17 2.818 17 3.824V19.63zm1.25-15.806c0-.335.28-.608.625-.608h1.25c.345 0 .625.273.625.608V19.63c0 .336-.28.608-.625.608h-1.25a.617.617 0 01-.625-.608V3.824z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$T = /*#__PURE__*/React__namespace.forwardRef(SvgGridCol);

  function SvgGridRow(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 3.875C2 2.841 2.841 2 3.875 2h16.25C21.16 2 22 2.84 22 3.875v1.25C22 6.159 21.16 7 20.125 7H3.875A1.877 1.877 0 012 5.125v-1.25zm18.75 0a.625.625 0 00-.625-.625H3.875a.625.625 0 00-.625.625v1.25c0 .345.28.625.625.625h16.25c.346 0 .625-.28.625-.625v-1.25zM2 11.375c0-1.033.84-1.874 1.875-1.874h16.25c1.034 0 1.875.84 1.875 1.875v1.25c0 1.034-.84 1.875-1.875 1.875H3.875A1.877 1.877 0 012 12.626v-1.25zm18.75 0a.625.625 0 00-.625-.624H3.875a.625.625 0 00-.625.625v1.25c0 .345.28.625.625.625h16.25c.345 0 .625-.28.625-.625v-1.25zM3.875 17C2.841 17 2 17.84 2 18.875v1.25C2 21.159 2.84 22 3.875 22h16.25C21.159 22 22 21.16 22 20.125v-1.25C22 17.841 21.16 17 20.125 17H3.875zm16.25 1.25c.345 0 .625.28.625.625v1.25c0 .345-.28.625-.625.625H3.875a.625.625 0 01-.625-.625v-1.25c0-.345.28-.625.625-.625h16.25z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$S = /*#__PURE__*/React__namespace.forwardRef(SvgGridRow);

  function SvgHamburger(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 7.25H3v-2.5h18v2.5zm0 6H3v-2.5h18v2.5zm-18 6h18v-2.5H3v2.5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$R = /*#__PURE__*/React__namespace.forwardRef(SvgHamburger);

  function SvgHandshake(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.95 4.222l-1.415-1.414a2 2 0 00-2.828 0l-2.815 2.814L8.877 3.53l-.706-.735-.721.72-5.657 5.658-.697.697.687.707 3.652 3.755a3.4 3.4 0 00.777 3.609l2.262 2.263a3.4 3.4 0 003.674.75 4.001 4.001 0 005.095-.468l.707-.707.707-.707a4.002 4.002 0 00.618-4.86l3.624-3.625.707-.707-.707-.707-4.95-4.95zm-4.19 15.326a2 2 0 002.068-.477l.707-.707.708-.707a2 2 0 000-2.828l-3.536-3.536-1.414 1.414-.707.707-.708-.707-2.12-2.121a2 2 0 010-2.829l.72-.72L8.143 5.65 3.904 9.889l2.786 2.864a2.6 2.6 0 013.199.379l3.394 3.394c.818.817.977 2.044.477 3.022zm4.19-6.84l-2.829-2.83.707-.706-1.414-1.415-2.829 2.829-1.414-1.414 1.415-1.415 3.535-3.535 1.414 1.414 4.243 4.243-2.828 2.828zM7.626 14.545a.6.6 0 01.848 0l3.395 3.394a.6.6 0 010 .848 1.4 1.4 0 01-1.98 0l-2.263-2.262a1.4 1.4 0 010-1.98z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$Q = /*#__PURE__*/React__namespace.forwardRef(SvgHandshake);

  function SvgHealthInsurance(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.512 4.493c.312.316.488.745.488 1.191v12.632c0 .447-.176.875-.488 1.19a1.657 1.657 0 01-1.179.494H3.667c-.442 0-.866-.177-1.179-.493A1.693 1.693 0 012 18.316V5.684c0-.446.176-.875.488-1.19A1.658 1.658 0 013.667 4h16.666c.442 0 .866.177 1.179.493zm-17.723 13.7a.415.415 0 00.294.123h15.834c.11 0 .216-.045.294-.123a.424.424 0 00.122-.298V9.053a.423.423 0 00-.122-.298.414.414 0 00-.294-.123H4.083a.414.414 0 00-.294.123.423.423 0 00-.122.298v8.842c0 .111.044.218.122.297zM9.292 12h.833c.166 0 .325.067.442.185a.636.636 0 01.183.447v1.263a.636.636 0 01-.183.446.622.622 0 01-.442.185h-.833a.207.207 0 00-.148.062.212.212 0 00-.06.149v.842a.636.636 0 01-.184.446.622.622 0 01-.442.186h-1.25a.622.622 0 01-.441-.186.636.636 0 01-.184-.446v-.842a.212.212 0 00-.06-.149.207.207 0 00-.148-.062h-.833a.622.622 0 01-.442-.185.636.636 0 01-.183-.446v-1.263c0-.168.066-.328.183-.447A.622.622 0 015.542 12h.833a.207.207 0 00.147-.062.211.211 0 00.061-.149v-.842c0-.167.066-.328.184-.446a.622.622 0 01.441-.185h1.25c.166 0 .325.067.442.185a.636.636 0 01.183.446v.843c0 .055.022.109.061.148.04.04.092.062.148.062zm8.75-.21h-3.959a.621.621 0 00-.442.184.635.635 0 000 .894.622.622 0 00.442.184h3.959a.622.622 0 00.442-.184.635.635 0 000-.894.622.622 0 00-.442-.185zm-3.959 2.526H17c.166 0 .325.066.442.185a.635.635 0 010 .893.622.622 0 01-.442.185h-2.917a.622.622 0 01-.442-.185.635.635 0 010-.893.621.621 0 01.442-.185z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$P = /*#__PURE__*/React__namespace.forwardRef(SvgHealthInsurance);

  function SvgHeartbeat(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.857 10.694a1 1 0 00-1.69-.04l-1.702 2.554H1v2h6.535l1.42-2.13.688 1.145 1.5 2.5a1 1 0 001.751-.067l1.277-2.553.829 1.105h8v-2h-7l-1.2-1.6a1 1 0 00-1.694.153l-1.186 2.37-2.063-3.437zm-7.002-4.58c.833-1.569 2.329-2.906 4.285-2.906 1.806 0 3.249.925 4.185 1.75.256.226.481.45.675.66.193-.21.42-.434.675-.66.936-.825 2.379-1.75 4.184-1.75 1.92 0 3.397 1.288 4.237 2.816.827 1.507 1.156 3.438.693 5.184h-2.117a2.768 2.768 0 00.165-.444c.343-1.206.128-2.643-.494-3.777-.627-1.141-1.543-1.779-2.484-1.779-1.11 0-2.097.576-2.861 1.25a7.652 7.652 0 00-1.096 1.204l-.053.075-.01.016a1 1 0 01-1.678 0l-.063-.09a7.636 7.636 0 00-1.096-1.204c-.765-.675-1.751-1.25-2.862-1.25-.958 0-1.892.663-2.518 1.843-.62 1.17-.809 2.641-.418 3.848.03.092.071.195.124.308H2.21c-.455-1.714-.145-3.604.644-5.093zM14.73 17.209h2.782a84.399 84.399 0 01-2.795 2.822 99.45 99.45 0 01-2.007 1.884l-.03.027-.01.01a1 1 0 01-1.34 0l-.01-.01-.03-.027a90.301 90.301 0 01-.541-.496c-.363-.337-.874-.816-1.466-1.388a84.585 84.585 0 01-2.796-2.822H9.27A92.235 92.235 0 0012 19.85a98.441 98.441 0 002.73-2.642z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$O = /*#__PURE__*/React__namespace.forwardRef(SvgHeartbeat);

  function SvgHome(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.293 1.293a1 1 0 011.414 0l10 10-1.414 1.414L20 11.414V20a2 2 0 01-2 2H6a2 2 0 01-2-2v-8.586l-1.293 1.293-1.414-1.414 10-10zM10 20h4v-4a2 2 0 10-4 0v4zm6 0h2V9.414l-6-6-6 6V20h2v-4a4 4 0 018 0v4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$N = /*#__PURE__*/React__namespace.forwardRef(SvgHome);

  function SvgHomeCollection(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.208h4V8.622l-5-5-5 5v8.586h7v-5h-1v-2zm1.126 9H6a2 2 0 01-2-2v-6.585l-1.293 1.292-1.414-1.414 9-9a1 1 0 011.414 0l8.707 8.707H22v2h-1v6a4 4 0 01-7.874 1zm4.874-7h-3v3h4v-3h-1z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$M = /*#__PURE__*/React__namespace.forwardRef(SvgHomeCollection);

  function SvgHospital(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.1 2C9.243 2 6.938 4.595 6.938 7.761s2.305 5.762 5.162 5.762c2.857 0 5.162-2.596 5.162-5.762C17.262 4.595 14.957 2 12.1 2zM8.263 7.761c0-2.383 1.731-4.303 3.837-4.303s3.838 1.92 3.838 4.303c0 2.384-1.732 4.304-3.838 4.304s-3.837-1.92-3.837-4.304zM12.1 4.516c-.376 0-.662.337-.662.729v1.787H9.85c-.376 0-.662.338-.662.73 0 .39.286.728.662.728h1.588v1.787c0 .392.286.73.662.73.376 0 .662-.338.662-.73V8.49h1.588c.376 0 .662-.337.662-.729 0-.391-.286-.729-.662-.729h-1.588V5.245c0-.392-.286-.729-.662-.729zM5.77 9.092a.62.62 0 00-.395.144l-2.11 1.73a.76.76 0 00-.265.585v9.42c0 .392.287.729.663.729h16.875c.375 0 .662-.337.662-.73v-9.419a.759.759 0 00-.267-.584l-2.109-1.73a.617.617 0 00-.396-.145.648.648 0 00-.538.303c-.21.32-.15.772.142 1.01l1.843 1.512v8.325H4.325v-8.325l1.842-1.511c.291-.24.352-.691.141-1.011a.648.648 0 00-.537-.303zm.705 5.489c-.376 0-.662.337-.662.729 0 .391.286.729.662.729H7.6c.376 0 .663-.338.663-.73 0-.391-.287-.728-.663-.728H6.475zm3.375 0c-.376 0-.662.337-.662.729 0 .391.286.729.662.729h1.125c.376 0 .662-.338.662-.73 0-.391-.286-.728-.662-.728H9.85zm3.375 0c-.376 0-.662.337-.662.729 0 .391.286.729.662.729h1.125c.376 0 .662-.338.662-.73 0-.391-.286-.728-.662-.728h-1.125zm3.375 0c-.376 0-.663.337-.663.729 0 .391.287.729.663.729h1.125c.376 0 .662-.338.662-.73 0-.391-.286-.728-.662-.728H16.6zM6.475 17.097c-.376 0-.662.337-.662.729 0 .392.286.729.662.729H7.6c.376 0 .663-.337.663-.73 0-.39-.287-.728-.663-.728H6.475zm3.375 0c-.376 0-.662.337-.662.729 0 .392.286.729.662.729h1.125c.376 0 .662-.337.662-.73 0-.39-.286-.728-.662-.728H9.85zm3.375 0c-.376 0-.662.337-.662.729 0 .392.286.729.662.729h1.125c.376 0 .662-.337.662-.73 0-.39-.286-.728-.662-.728h-1.125zm3.375 0c-.376 0-.663.337-.663.729 0 .392.287.729.663.729h1.125c.376 0 .662-.337.662-.73 0-.39-.286-.728-.662-.728H16.6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$L = /*#__PURE__*/React__namespace.forwardRef(SvgHospital);

  function SvgId(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 18v-6h5V7h11v11H4zM7 7H4v3h3V7zm2-2h12a1 1 0 011 1v13a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h6zm10 7h-8v-2h8v2zM5 16h14v-2H5v2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$K = /*#__PURE__*/React__namespace.forwardRef(SvgId);

  function SvgInfoRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2 12.176a10.04 10.04 0 002.965 7.012 9.709 9.709 0 007.05 2.814 10.173 10.173 0 007.092-3.044 9.836 9.836 0 002.892-7.13A9.817 9.817 0 0012.164 2h-.18A10.092 10.092 0 002 12.176zm11.21 4.672a1.211 1.211 0 11-2.421 0v-5.45a1.211 1.211 0 112.421 0v5.45zM11.973 5.921h.026a1.514 1.514 0 11.026 3.028h-.026a1.514 1.514 0 11-.024-3.028h-.002z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$J = /*#__PURE__*/React__namespace.forwardRef(SvgInfoRound);

  function SvgLab(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3.208h-1v2.5h2.25v5.167L4.6 16.408c-1.483 1.978-.072 4.8 2.4 4.8h10c2.472 0 3.883-2.822 2.4-4.8l-4.15-5.533V5.708h2.25v-2.5h-10zm3.25 3.75v-1.75h2.5v6.334l.2.266 2.55 3.4H8l2.55-3.4.2-.266V6.958zM6.5 17.208l-.3.4a1 1 0 00.8 1.6h10a1 1 0 00.8-1.6l-.3-.4h-11z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$I = /*#__PURE__*/React__namespace.forwardRef(SvgLab);

  function SvgLink(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.071 4.929a5 5 0 00-7.071 0L9.172 7.757l1.414 1.414 2.828-2.828a3 3 0 114.243 4.243l-2.829 2.828 1.415 1.414L19.07 12a5 5 0 000-7.071zM6.343 13.414l2.121-2.121L7.05 9.879l-2.121 2.12A5 5 0 0012 19.072l2.121-2.121-1.414-1.415-2.121 2.122a3 3 0 11-4.243-4.243zm10.607-4.95L15.536 7.05 7.05 15.536l1.414 1.414 8.486-8.486z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$H = /*#__PURE__*/React__namespace.forwardRef(SvgLink);

  function SvgList(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.6 4a1.6 1.6 0 100 3.2h2.133a1.6 1.6 0 100-3.2H5.6zM4 11.4a1 1 0 011-1h14a1 1 0 011 1v1.2a1 1 0 01-1 1H5a1 1 0 01-1-1v-1.2zm0 6.4a1 1 0 011-1h14a1 1 0 011 1V19a1 1 0 01-1 1H5a1 1 0 01-1-1v-1.2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$G = /*#__PURE__*/React__namespace.forwardRef(SvgList);

  function SvgLoading(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.556 3.685A9 9 0 0121 12h-2a7 7 0 10-3.5 6.062l1 1.732A9 9 0 118.556 3.685z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$F = /*#__PURE__*/React__namespace.forwardRef(SvgLoading);

  function SvgLock(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 20v-9h12v9H6zM4 9h2c0-2.04.392-4.003 1.346-5.49C8.334 1.97 9.894 1 12 1s3.666.97 4.654 2.51C17.608 4.997 18 6.96 18 9h2v12a1 1 0 01-1 1H5a1 1 0 01-1-1V9zm12 0c0-1.827-.358-3.363-1.03-4.41C14.335 3.597 13.395 3 12 3c-1.394 0-2.334.597-2.97 1.59C8.357 5.637 8 7.173 8 9h8zm-3 7.732A2 2 0 0012 13a2 2 0 00-1 3.732V18h2v-1.268z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$E = /*#__PURE__*/React__namespace.forwardRef(SvgLock);

  function SvgMail(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.568 7L12 11.809 19.432 7H4.568zM4 9.015V17h16V9.015l-7.457 4.825-.543.351-.543-.351L4 9.015zM2 6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$D = /*#__PURE__*/React__namespace.forwardRef(SvgMail);

  function SvgMedicalCalendar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 6.73h2v.958c0 .529.448.958 1 .958s1-.43 1-.958v-.959h6v.959c0 .529.448.958 1 .958s1-.43 1-.958v-.959h2v12.459H5V6.729zm12-1.917h4v14.375c0 1.058-.895 1.916-2 1.916H5c-1.105 0-2-.858-2-1.916V4.813h4V2.896h2v1.917h6V2.896h2v1.917zm-6 4.791v2.875H8v1.917h3v2.875h2v-2.875h3v-1.917h-3V9.604h-2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$C = /*#__PURE__*/React__namespace.forwardRef(SvgMedicalCalendar);

  function SvgMenu(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 6a2 2 0 114 0 2 2 0 01-4 0zm0 6a2 2 0 114 0 2 2 0 01-4 0zm2 4a2 2 0 100 4 2 2 0 000-4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$B = /*#__PURE__*/React__namespace.forwardRef(SvgMenu);

  function SvgMessage(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 18v-2H4V6h16v10h-9.273l-.572.52L8 18.48V18zm12 0h-8.5l-3.827 3.48C7.03 22.062 6 21.607 6 20.74V18H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2zM6 10h12V8H6v2zm0 4h8v-2H6v2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$A = /*#__PURE__*/React__namespace.forwardRef(SvgMessage);

  function SvgMicOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 6.586L4.707 3.293 3.293 4.707 8 9.414V12a4 4 0 006.032 3.446l.803.803c-.657.446-1.561.751-2.835.751-1.505 0-2.494-.45-3.172-1.062-.699-.63-1.152-1.508-1.433-2.484-.487-1.689-.401-3.396-.363-4.146.006-.136.012-.24.012-.308h-2v-.002V9l-.002.035-.006.114v.014a17.932 17.932 0 00-.031 1.526c.02.922.122 2.12.468 3.32.345 1.197.95 2.454 2.015 3.415.89.804 2.049 1.35 3.512 1.52V22h2v-3.054c1.33-.149 2.409-.597 3.266-1.266l3.027 3.027 1.414-1.414-3.096-3.096c.42-.65.712-1.352.914-2.04.59-2.001.481-4.138.442-4.906a6.362 6.362 0 01-.01-.25l-2-.001c0 .109.006.258.014.44.038.882.11 2.541-.364 4.152-.12.404-.27.79-.456 1.144l-.705-.704c.352-.596.554-1.29.554-2.032V6a4 4 0 10-8 0v.586zm2 4.828V12a2 2 0 002.518 1.932L10 11.414zm3.932 1.104L10 8.586V6a2 2 0 014 0v6a2 2 0 01-.068.518z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$z = /*#__PURE__*/React__namespace.forwardRef(SvgMicOff);

  function SvgMicOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.044 9v-.002V9l-.002.035a15.13 15.13 0 01-.006.114v.014a17.939 17.939 0 00-.031 1.526c.02.922.122 2.12.468 3.32.345 1.197.95 2.454 2.015 3.415.89.804 2.05 1.35 3.512 1.52V22h2v-3.054c1.452-.162 2.606-.682 3.498-1.457 1.07-.93 1.68-2.152 2.027-3.331.59-2.002.481-4.14.442-4.907-.006-.118-.01-.203-.01-.25l-2-.001c0 .109.006.258.014.44.038.882.11 2.541-.364 4.152-.279.946-.727 1.786-1.42 2.387C14.51 16.566 13.518 17 12 17c-1.505 0-2.493-.45-3.172-1.062-.699-.63-1.152-1.508-1.433-2.484-.487-1.689-.401-3.396-.363-4.146.006-.136.012-.24.012-.308h-2zM14 12V6a2 2 0 00-4 0v6a2 2 0 104 0zM12 2a4 4 0 00-4 4v6a4 4 0 008 0V6a4 4 0 00-4-4z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$y = /*#__PURE__*/React__namespace.forwardRef(SvgMicOn);

  function SvgNotification(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6c-2.171 0-5 2.038-5 6.647V17h10v-4.353C17 8.038 14.171 6 12 6zm2-1.651V4a2 2 0 10-4 0v.349c-2.71.958-5 3.862-5 8.298V19h4a3 3 0 106 0h4v-6.353c0-4.436-2.29-7.34-5-8.298zM12 20a1 1 0 01-1-1h2a1 1 0 01-1 1z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$x = /*#__PURE__*/React__namespace.forwardRef(SvgNotification);

  function SvgPdf(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 4h20v2H2V4zm20 4h-5v8h2v-2.231h2v-2h-2V10h3V8zM9.5 8h5l1 1v6l-1 1h-5V8zm2 2v4h2v-4h-2zM2 8h5l1 1v4l-1 1H4v2H2V8zm2 4h2v-2H4v2zm18 6H2v2h20v-2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$w = /*#__PURE__*/React__namespace.forwardRef(SvgPdf);

  function SvgPhone(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.199 5.68c-.398.484-.654.926-.752 1.217-.237.706-.662 4.317 3.353 8.062 2.035 1.898 3.948 2.8 5.417 3.198 1.516.411 2.496.274 2.68.209.234-.083.64-.306 1.134-.673.454-.338.933-.76 1.354-1.22a902.175 902.175 0 00-2.698-2.591l-1.511 1.511-.416.419-.568-.162c-.29-.083-2.328-.68-4.175-2.527-.927-.926-1.412-1.761-1.659-2.448a3.995 3.995 0 01-.21-.873c-.027-.213-.028-.433-.027-.411l-.023-.455.328-.315c.116-.112.89-.887 1.496-1.494l-2.528-2.6c-.418.31-.84.72-1.195 1.153zM4.653 4.41a8.8 8.8 0 011.713-1.607c.826-.575 1.83-.32 2.406.272.682.7 1.846 1.899 2.585 2.66a1.998 1.998 0 01-.018 2.804l-1.18 1.18c.017.081.043.173.081.28.135.376.446.965 1.19 1.71a8.387 8.387 0 002.771 1.83l1.072-1.072a1.997 1.997 0 012.795-.032c.759.727 1.965 1.882 2.753 2.645.7.676.85 1.84.124 2.65a11.842 11.842 0 01-1.72 1.568c-.564.419-1.156.775-1.663.954-.702.248-2.127.308-3.869-.165-1.788-.485-3.988-1.55-6.257-3.666C2.842 12.137 3.066 7.703 3.55 6.26c.206-.612.627-1.27 1.102-1.848z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$v = /*#__PURE__*/React__namespace.forwardRef(SvgPhone);

  function SvgPictureInPicture(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18 11h-8v6h8v-6zm4 8V4.98C22 3.88 21.1 3 20 3H4c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 .02H4V4.97h16v14.05z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$u = /*#__PURE__*/React__namespace.forwardRef(SvgPictureInPicture);

  function SvgPin(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c-1.124 0-3.087.274-4.803 1.41C5.418 4.59 4 6.643 4 9.955c0 3.347 1.95 6.342 3.745 8.411a25.515 25.515 0 003.335 3.19c.101.08.182.142.238.184l.066.05.019.013.006.005h.001l.001.001L12 21l-.588.809a1 1 0 001.176 0L12 21c.588.809.588.808.589.808l.002-.002.006-.004.018-.013.066-.05a22.629 22.629 0 001.068-.873 25.524 25.524 0 002.506-2.5C18.051 16.295 20 13.3 20 9.953c0-3.312-1.418-5.364-3.198-6.543C15.087 2.274 13.123 2 12 2zm.438 17.357c-.162.14-.309.264-.438.37a23.521 23.521 0 01-2.745-2.673C7.551 15.09 6 12.563 6 9.955c0-2.641 1.082-4.067 2.302-4.876C9.587 4.226 11.123 4 12 4c.877 0 2.413.226 3.697 1.078C16.919 5.887 18 7.313 18 9.954c0 2.608-1.55 5.136-3.255 7.1a23.516 23.516 0 01-2.307 2.303zM10 10a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$t = /*#__PURE__*/React__namespace.forwardRef(SvgPin);

  function SvgPortraitFrame(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 4a1 1 0 00-1-1h-5v2h4v4h2V4zM4 3a1 1 0 00-1 1v5h2V5h4V3H4zm17 18a1 1 0 01-1 1h-5v-2h4v-4h2v5zM3 21a1 1 0 001 1h5v-2H5v-4H3v5zm6.684-4.145C9.15 17.355 9 17.859 9 18H7c0-.859.517-1.855 1.316-2.605C9.158 14.605 10.4 14 12 14c1.6 0 2.842.606 3.684 1.395C16.483 16.145 17 17.141 17 18h-2c0-.141-.15-.645-.684-1.145-.491-.46-1.25-.855-2.316-.855-1.066 0-1.825.394-2.316.855zM13 10a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$s = /*#__PURE__*/React__namespace.forwardRef(SvgPortraitFrame);

  function SvgPrint(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 7a1 1 0 00-1 1v8a1 1 0 001 1h3v4a1 1 0 001 1h10a1 1 0 001-1v-4h3a1 1 0 001-1V8a1 1 0 00-1-1h-3V5a1 1 0 00-.375-.78l-2.5-2A1 1 0 0014.5 2H7a1 1 0 00-1 1v4H3zm5 0h8V5.48L14.15 4H8v3zM7 9H4v6h2v-3h12v3h2V9H7zm9 11H8v-6h8v6zm-2-2h-4v-2h4v2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$r = /*#__PURE__*/React__namespace.forwardRef(SvgPrint);

  function SvgQuestion(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-.794-12.735C11.09 9.405 11 9.65 11 10H9c0-.649.16-1.404.67-2.015C10.204 7.342 11.01 7 12 7s1.795.342 2.33.985c.51.61.67 1.366.67 2.015 0 1.376-.726 2.368-1.34 2.966-.236.231-.47.416-.66.555V14h-2v-.919a1.003 1.003 0 01.303-.805l.001-.001a1.696 1.696 0 01.203-.157l.004-.002.043-.029c.045-.029.092-.059.152-.1.154-.105.357-.257.558-.453.412-.402.736-.91.736-1.534 0-.351-.09-.596-.206-.735C12.705 9.158 12.51 9 12 9c-.51 0-.705.158-.794.265zM13 17v-2h-2v2h2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$q = /*#__PURE__*/React__namespace.forwardRef(SvgQuestion);

  function SvgRadioOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$p = /*#__PURE__*/React__namespace.forwardRef(SvgRadioOff);

  function SvgRadioOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM12 6a6 6 0 106 6 6.007 6.007 0 00-6-6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$o = /*#__PURE__*/React__namespace.forwardRef(SvgRadioOn);

  function SvgRefresh(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.376 5.293c-1.238.3-2.37.938-3.27 1.84a6.95 6.95 0 00-1.698 7.008.21.21 0 00.316.111l1.126-.74a.84.84 0 011.285.871l-.768 3.703a.84.84 0 01-.991.655l-3.704-.763a.84.84 0 01-.292-1.526l1.176-.775a.208.208 0 00.08-.252A9.035 9.035 0 0114.763 3.43a1.05 1.05 0 11-.639 2 6.92 6.92 0 00-3.749-.137zm11.393 1.123a.84.84 0 01.218.436.84.84 0 01-.38.859l-1.131.71a.208.208 0 00-.084.253A9.034 9.034 0 019.337 20.667a1.051 1.051 0 11.62-2.007A6.932 6.932 0 0018.6 9.9a.211.211 0 00-.128-.134.208.208 0 00-.184.023l-1.212.761a.84.84 0 01-1.267-.898l.84-3.687a.841.841 0 011.01-.632l3.687.84a.84.84 0 01.423.243z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$n = /*#__PURE__*/React__namespace.forwardRef(SvgRefresh);

  function SvgRemove(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$m = /*#__PURE__*/React__namespace.forwardRef(SvgRemove);

  function SvgRemoveRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM6 12a1 1 0 011-1h10a1 1 0 110 2H7a1 1 0 01-1-1z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$l = /*#__PURE__*/React__namespace.forwardRef(SvgRemoveRound);

  function SvgSearch(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.036 15.306l5.707 5.47 1.414-1.356-5.707-5.47c2.055-2.627 1.836-6.37-.657-8.76-2.734-2.62-7.166-2.62-9.9 0-2.733 2.62-2.733 6.867 0 9.487 2.494 2.39 6.4 2.6 9.143.63zM13.4 13.3l-.046.044c-1.954 1.85-5.103 1.842-7.048-.022a4.652 4.652 0 010-6.776c1.953-1.871 5.119-1.871 7.072 0a4.651 4.651 0 01.022 6.754z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$k = /*#__PURE__*/React__namespace.forwardRef(SvgSearch);

  function SvgSecurity(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.033 1.823a2 2 0 00-2.066 0l-6.483 3.91L4 6.025V11.867c0 3.564 1.973 6.188 3.83 7.867a16.762 16.762 0 003.41 2.373 10.075 10.075 0 00.317.157l.02.01.007.003h.002l.001.001.413-.91-.412.91.412.187.412-.187-.412-.91.413.91.003-.001.007-.003.02-.01a10.075 10.075 0 00.317-.157 16.76 16.76 0 003.41-2.373c1.857-1.68 3.83-4.303 3.83-7.867V6.025l-.483-.292-6.484-3.91zm-.456 18.094c-.224.135-.42.245-.577.33a14.762 14.762 0 01-2.83-1.996C7.528 16.763 6 14.637 6 11.867V7.154l6-3.619 6 3.62v4.712c0 2.77-1.527 4.896-3.17 6.384a14.764 14.764 0 01-2.253 1.666zm3.13-8.843l.707-.707L15 8.953l-.707.707-2.793 2.793-1.293-1.293-.707-.707-1.414 1.414.707.707 2 2 .707.707.707-.707 3.5-3.5z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$j = /*#__PURE__*/React__namespace.forwardRef(SvgSecurity);

  function SvgSettings(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2 4.208a2 2 0 00-2-2h-2a2 2 0 00-2 2v.505a7.925 7.925 0 00-.123.047l-.471-.471a2 2 0 00-2.829 0L4.363 5.703a2 2 0 000 2.828l.357.357-.054.12H4a2 2 0 00-2 2v2a2 2 0 002 2h.504l.047.123-.47.471a2 2 0 000 2.829l1.414 1.414a2 2 0 002.828 0l.357-.357c.17.078.344.15.52.216v.504a2 2 0 002 2h2a2 2 0 002-2v-.666l.12-.054.357.357a2 2 0 002.828 0l1.415-1.414a2 2 0 000-2.829l-.471-.47.047-.124H20a2 2 0 002-2v-2a2 2 0 00-2-2h-.666a8.372 8.372 0 00-.054-.12l.357-.357a2 2 0 000-2.828l-1.415-1.414a2 2 0 00-2.828 0l-.194.194v-.275zM8.644 7.155l.047.047a5.964 5.964 0 012.509-.94V4.207h2v2.12c.766.156 1.48.457 2.109.874l1.5-1.5 1.413 1.415-1.451 1.452c.54.706.926 1.536 1.109 2.44H20v2h-2.053a5.964 5.964 0 01-.941 2.508l1.5 1.5-1.415 1.414-1.452-1.452a5.972 5.972 0 01-2.439 1.11v2.12h-2v-2.054a5.97 5.97 0 01-2.84-1.176L6.91 18.43l-1.414-1.414 1.5-1.5a5.964 5.964 0 01-.942-2.509H4v-2h2.12A5.973 5.973 0 017.23 8.57L5.776 7.117l1.415-1.414 1.452 1.452zM11 12.208a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$i = /*#__PURE__*/React__namespace.forwardRef(SvgSettings);

  function SvgShare(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 8a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 10-3.892-3.07L9.27 9.694a4 4 0 10-.252 4.932l5.07 2.535a4 4 0 10.895-1.788l-5.07-2.536a4.016 4.016 0 00.067-1.246l5.067-2.895A3.99 3.99 0 0018 10zm0 10a2 2 0 100-4 2 2 0 000 4zM8 12a2 2 0 11-4 0 2 2 0 014 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$h = /*#__PURE__*/React__namespace.forwardRef(SvgShare);

  function SvgStethoscope(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.8 15.526a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm3.2-1.2a3.201 3.201 0 01-2.035 2.982 7.472 7.472 0 01-.933 2.67c-.78 1.318-2.193 2.615-4.532 2.615-1.104 0-2.043-.253-2.819-.722-.774-.467-1.331-1.116-1.726-1.827C8.18 18.65 8 16.966 8 15.66V12.522c-.933-.137-1.73-.47-2.396-.966-.884-.658-1.469-1.551-1.853-2.489-.758-1.846-.805-4.028-.72-5.53a19.891 19.891 0 01.208-1.959l.02-.122.007-.034.002-.01v-.005l.983.186.983.187-.001.004-.004.022-.017.096a17.89 17.89 0 00-.185 1.747C4.96 4.872 5 6.395 5.39 7.705c.79-.59 1.966-1.112 3.61-1.112s2.82.523 3.61 1.112c.39-1.31.431-2.833.363-4.056a17.9 17.9 0 00-.185-1.747 8.688 8.688 0 00-.017-.096l-.004-.022V1.78l.982-.187.982-.186v.002l.001.003.002.01.006.034a10.802 10.802 0 01.086.563c.05.374.11.9.144 1.518.084 1.502.037 3.684-.72 5.53-.385.938-.97 1.83-1.854 2.489-.666.496-1.463.83-2.396.966V15.661c0 1.178.174 2.46.703 3.412.257.461.587.83 1.012 1.087.423.255.995.433 1.785.433 1.45 0 2.287-.75 2.81-1.634a5.415 5.415 0 00.607-1.556 3.201 3.201 0 01.883-6.277 3.2 3.2 0 013.2 3.2zM11.67 9.52a3.051 3.051 0 00-.17-.146c-.46-.368-1.243-.78-2.5-.78s-2.04.412-2.5.78c-.062.05-.118.098-.17.146.143.161.299.306.468.432.509.378 1.207.641 2.202.641.995 0 1.693-.263 2.202-.641.169-.126.325-.27.467-.432z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$g = /*#__PURE__*/React__namespace.forwardRef(SvgStethoscope);

  function SvgSun(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 11a1 1 0 010 2h-4v-2h4zm-2.293-6.707a1 1 0 010 1.414l-1.414 1.414-1.414 1.415-1.415-1.415 1.415-1.414 1.414-1.414a1 1 0 011.414 0zM12 14a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zm0-15a1 1 0 011 1v4h-2V2a1 1 0 011-1zm1 21v-4h-2v4a1 1 0 002 0zm6.707-2.293a1 1 0 000-1.414l-2.829-2.829-1.414 1.415 2.829 2.828a1 1 0 001.414 0zm-15.243-14a1 1 0 111.414-1.414L8.707 7.12 7.293 8.536 4.464 5.707zM1.171 12a1 1 0 011-1h4v2h-4a1 1 0 01-1-1zm3.293 6.293a1 1 0 101.414 1.414l2.829-2.828-1.414-1.415-2.829 2.829z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$f = /*#__PURE__*/React__namespace.forwardRef(SvgSun);

  function SvgSwap(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 18a5 5 0 005-5v-1h-2v1a3 3 0 01-3 3H7.414l1.293-1.293.707-.707L8 12.586l-.707.707-3 3a1 1 0 000 1.414l3 3 .707.707L9.414 20l-.707-.707L7.414 18H15zm4.707-10.293a1 1 0 000-1.414l-3-3L16 2.586 14.586 4l.707.707L16.586 6H9a5 5 0 00-5 5v1h2v-1a3 3 0 013-3h7.586l-1.293 1.293-.707.707L16 11.414l.707-.707 3-3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$e = /*#__PURE__*/React__namespace.forwardRef(SvgSwap);

  function SvgTelemedicine(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.815 18.209a2.796 2.796 0 01-.276-.397.376.376 0 00-.325-.188H4.875a.375.375 0 01-.375-.374V5.625a.375.375 0 01.375-.375h8.25a.375.375 0 01.375.375v1.32a.375.375 0 00.375.374c.224 0 .447.025.665.075a.375.375 0 00.46-.367V5.25A2.257 2.257 0 0012.75 3h-7.5A2.257 2.257 0 003 5.25v13.5A2.257 2.257 0 005.25 21h4.084a.374.374 0 00.288-.615l-1.807-2.176zm.247-5.834h1.125a.567.567 0 00.563-.563v-.75a.188.188 0 01.187-.187h.75a.187.187 0 00.188-.188v-.367c0-.396.08-.788.236-1.151a.375.375 0 00-.172-.48.54.54 0 00-.252-.064h-.75a.187.187 0 01-.187-.188v-.75a.566.566 0 00-.563-.563H8.062a.566.566 0 00-.562.563v.75a.187.187 0 01-.188.187h-.75A.566.566 0 006 9.187v1.125a.566.566 0 00.562.562h.75a.187.187 0 01.188.188v.75a.566.566 0 00.562.563zm7.688 1.875h1.5A3.754 3.754 0 0121 18v2.25a.75.75 0 01-1.5 0V18a2.25 2.25 0 00-2.25-2.25H15a.75.75 0 01-.75-.75v-4.875a.375.375 0 00-.75 0v7.368a.75.75 0 01-1.327.48l-1.76-2.116a.375.375 0 00-.577.479l2.854 3.434a.75.75 0 11-1.154.96l-2.854-3.435a1.874 1.874 0 01.886-2.99 1.877 1.877 0 011.998.59l.434.526v-5.296a1.875 1.875 0 013.75 0v4.125z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$d = /*#__PURE__*/React__namespace.forwardRef(SvgTelemedicine);

  function SvgTerms(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 5h14v14H5V5zM3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm4 4h10V7H7v2zm6 4H7v-2h6v2zm-6 4h8v-2H7v2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$c = /*#__PURE__*/React__namespace.forwardRef(SvgTerms);

  function SvgTrashBin(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 8h1V6h-4V4a2 2 0 00-2-2H9a2 2 0 00-2 2v2H3v2h1v12a2 2 0 002 2h12a2 2 0 002-2V8zm-2 0H6v12h12V8zM9 6h6V4H9v2zm2 4v8H9v-8h2zm4 8v-8h-2v8h2z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$b = /*#__PURE__*/React__namespace.forwardRef(SvgTrashBin);

  function SvgTweezer(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 4.015a1.015 1.015 0 00-1.65-.79L8.209 12.253a.189.189 0 01-.294-.08 2.538 2.538 0 00-4.466-.54 2.537 2.537 0 002.096 3.978 2.68 2.68 0 001.602-.568l3.845-3.116a.376.376 0 01.5.024l.553.542a.375.375 0 01.028.504L8.95 16.846a2.686 2.686 0 00-.568 1.6 2.54 2.54 0 002.693 2.55 2.545 2.545 0 002.377-2.847 2.542 2.542 0 00-1.63-2.07.188.188 0 01-.08-.294l9.035-11.132c.146-.18.226-.406.225-.638zM4.5 13.07a1.043 1.043 0 112.087-.002 1.043 1.043 0 01-2.086.002zm7.469 5.376a1.043 1.043 0 11-2.086.003 1.043 1.043 0 012.086-.003zm1.527-7.202a.374.374 0 01-.554.032l-.217-.214a.375.375 0 01.026-.56l2.536-2.055a.187.187 0 01.264.263l-2.055 2.534z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$a = /*#__PURE__*/React__namespace.forwardRef(SvgTweezer);

  function SvgUser(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 21a6 6 0 0112 0h2a8 8 0 10-16 0h2zm9-14a3 3 0 11-6 0 3 3 0 016 0zm2 0A5 5 0 117 7a5 5 0 0110 0z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$9 = /*#__PURE__*/React__namespace.forwardRef(SvgUser);

  function SvgVaccines(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.657 1.686l5.657 5.657-1.415 1.414-2.12-2.121-1.415 1.414 3.535 3.536L19.485 13l-1.414-1.414-2.822 2.822-.006.006-.007.006-2.108 2.109-.007.006-.007.008-2.821 2.82a1 1 0 01-1.414 0L7.464 17.95 3.93 21.485a1 1 0 01-1.414-1.414l3.535-3.536-1.414-1.414a1 1 0 010-1.414l7.778-7.778L11 4.515 12.414 3.1l3.536 3.536 1.414-1.414L15.243 3.1l1.414-1.414zM8.176 15.833l-.004-.005-.005-.004-1.41-1.41 7.071-7.07.708.706 1.414 1.414.707.707-2.121 2.122-.708-.707A1 1 0 1012.414 13l.707.707-.707.707-.707-.707a1 1 0 00-1.414 1.414l.707.707-1.414 1.415-1.41-1.41z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$8 = /*#__PURE__*/React__namespace.forwardRef(SvgVaccines);

  function SvgViewFile(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#view-file_svg__clip0_1347_7035)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 5.68v11.745a1.669 1.669 0 01-1.665 1.667h-7.918a.393.393 0 01-.238-.105l-.382-.382a.22.22 0 01-.01-.193 5.75 5.75 0 00.35-.846.2.2 0 01.191-.14h7.59a.416.416 0 00.417-.417V5.853a.418.418 0 00-.122-.294l-1.766-1.77a.416.416 0 00-.294-.121H9.097a.416.416 0 00-.416.417v5.94a.203.203 0 01-.271.188 5.756 5.756 0 00-1.21-.258.201.201 0 01-.184-.2V3.667A1.669 1.669 0 018.68 2h9.645c.441 0 .864.176 1.177.489l2.01 2.012c.311.313.487.737.487 1.18zM11.394 21.766l-2.086-2.09a.2.2 0 00-.253-.024 4.585 4.585 0 01-6.047-1.004 4.603 4.603 0 01.34-6.13 4.588 4.588 0 017.773 2.51 4.605 4.605 0 01-.66 3.22.2.2 0 00.024.25l2.087 2.089A.835.835 0 0111.98 22a.832.832 0 01-.586-.234zm-6.413-3.554a2.91 2.91 0 004.532-2.427 2.922 2.922 0 00-1.799-2.696 2.91 2.91 0 00-3.175.633 2.92 2.92 0 00.442 4.49zM18.656 8.1a.75.75 0 10-1.06-1.06l-2.27 2.27-.913-.913a.75.75 0 00-1.061 0l-2.64 2.64a.75.75 0 001.061 1.06l2.11-2.109.912.913a.75.75 0 001.06 0L18.657 8.1z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "view-file_svg__clip0_1347_7035"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$7 = /*#__PURE__*/React__namespace.forwardRef(SvgViewFile);

  function SvgViewOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.201 12a15.803 15.803 0 001.964 2.276C7.662 15.702 9.675 17 12 17c1.04 0 2.016-.26 2.912-.674l-.88-.88a4 4 0 01-5.478-5.478l-1.23-1.23c-.413.311-.801.645-1.16.986A15.812 15.812 0 004.202 12zM7.6 6.185L4.707 3.293 3.293 4.707 5.9 7.313c-.405.316-.777.642-1.114.963a17.81 17.81 0 00-2.453 2.913 10.498 10.498 0 00-.173.27l-.011.018-.003.005-.002.002c0 .001 0 .002.857.516l-.857-.514-.31.514.31.514L3 12l-.857.515.002.003.003.005.01.018a7.364 7.364 0 00.174.27 17.81 17.81 0 002.453 2.913C6.438 17.298 8.925 19 12 19c1.649 0 3.128-.49 4.4-1.185l2.893 2.892 1.414-1.414-2.605-2.606c.404-.316.776-.642 1.113-.963a17.815 17.815 0 002.453-2.913 10.14 10.14 0 00.174-.27l.01-.018.004-.005v-.002h.001c0-.001 0-.002-.857-.516l.858.514.308-.514-.308-.514L21 12c.858-.514.857-.515.857-.515l-.001-.003-.004-.005-.01-.018a7.346 7.346 0 00-.174-.27 17.817 17.817 0 00-2.453-2.913C17.562 6.702 15.075 5 12 5c-1.648 0-3.128.49-4.4 1.185zm1.488 1.488C9.984 7.26 10.96 7 12 7c2.325 0 4.338 1.298 5.835 2.724A15.81 15.81 0 0119.8 12a15.802 15.802 0 01-1.964 2.276c-.358.34-.745.675-1.16.985l-1.229-1.23a4 4 0 00-5.478-5.478l-.88-.88zm2.394 2.395a2.001 2.001 0 012.45 2.45l-2.45-2.45zm-1.414 1.414l2.45 2.45A2.004 2.004 0 0110 12a2 2 0 01.068-.518z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$6 = /*#__PURE__*/React__namespace.forwardRef(SvgViewOff);

  function SvgViewOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.447 12.338A14.627 14.627 0 014.201 12a15.81 15.81 0 011.964-2.276C7.662 8.298 9.675 7 12 7s4.338 1.298 5.835 2.724A15.81 15.81 0 0119.8 12a15.81 15.81 0 01-1.964 2.276C16.338 15.702 14.325 17 12 17s-4.338-1.298-5.835-2.724a15.81 15.81 0 01-1.718-1.938zM21 12l.857-.515L21 12zm.856-.518l.001.003.31.515-.31.514L21 12c.858.514.857.515.857.516l-.001.002-.004.005-.01.018a15.68 15.68 0 01-.688.997 17.808 17.808 0 01-1.94 2.186C17.563 17.298 15.076 19 12 19s-5.562-1.702-7.215-3.276a17.802 17.802 0 01-2.453-2.913 10.463 10.463 0 01-.17-.264l-.003-.006-.011-.018-.003-.005-.002-.004L3 12l-.857-.516.002-.002.003-.005.01-.018.038-.06a15.706 15.706 0 01.651-.937 17.813 17.813 0 011.938-2.186C6.438 6.702 8.925 5 12 5s5.562 1.702 7.215 3.276a17.82 17.82 0 012.453 2.913 10.185 10.185 0 01.174.27l.01.018.004.005zM3 12l-.857-.515-.31.515.31.514L3 12zm7 0a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$5 = /*#__PURE__*/React__namespace.forwardRef(SvgViewOn);

  function SvgViewPdf(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#view-pdf_svg__clip0_3954_10507)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 17.425V5.68a1.67 1.67 0 00-.488-1.179l-2.01-2.012A1.664 1.664 0 0018.327 2H8.68a1.664 1.664 0 00-1.665 1.668v6.086a.202.202 0 00.184.201c.412.043.817.129 1.21.258a.201.201 0 00.247-.096.203.203 0 00.024-.093v-5.94a.417.417 0 01.416-.416h9.056c.11 0 .216.043.294.121l1.767 1.77a.418.418 0 01.121.294v11.155a.417.417 0 01-.416.417h-7.59a.2.2 0 00-.192.141 5.75 5.75 0 01-.35.846.22.22 0 00.01.193l.382.382c.065.061.149.098.238.105h7.918A1.664 1.664 0 0022 17.425zM9.308 19.676l2.086 2.09a.832.832 0 001.411-.593.835.835 0 00-.233-.586l-2.087-2.09a.2.2 0 01-.025-.25 4.605 4.605 0 00-.992-6.058 4.586 4.586 0 00-6.12.329 4.602 4.602 0 002.492 7.79 4.585 4.585 0 003.215-.656.2.2 0 01.253.024zM6.6 18.703a2.91 2.91 0 01-2.691-1.801 2.923 2.923 0 01.631-3.18 2.912 2.912 0 014.974 2.063 2.92 2.92 0 01-.853 2.064 2.911 2.911 0 01-2.06.854zM19.4 8.385c0 .189-.11.384-.335.384h-.921v.816h.776c.24 0 .36.19.36.38 0 .194-.12.39-.36.39h-.776v1.21c0 .28-.16.435-.376.435s-.376-.155-.376-.434V8.434c0-.228.14-.434.39-.434h1.283c.22 0 .335.189.335.385zM13.792 8h.939c1.266 0 1.99.807 1.992 2.05 0 1.177-.77 1.939-1.935 1.939h-.985c-.186 0-.446-.1-.446-.42V8.43c0-.257.18-.431.435-.431zm.412 3.215h.572c.73 0 1.063-.531 1.063-1.203 0-.718-.34-1.239-1.12-1.239h-.515v2.442zM10.409 8h.93c.771 0 1.344.534 1.344 1.331 0 .814-.594 1.32-1.313 1.32h-.582v.915c0 .28-.168.434-.394.434S10 11.845 10 11.566V8.434c0-.262.146-.434.41-.434zm.379 1.917h.535c.33 0 .54-.257.541-.59 0-.335-.21-.592-.54-.592h-.536v1.182z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "view-pdf_svg__clip0_3954_10507"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$4 = /*#__PURE__*/React__namespace.forwardRef(SvgViewPdf);

  function SvgWarningRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1-16v7.6h-2V6h2zm-1 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$3 = /*#__PURE__*/React__namespace.forwardRef(SvgWarningRound);

  function SvgWhatsapp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12a8 8 0 114.4 7.147l-.212-.108H4.96v-3.227l-.107-.213A7.966 7.966 0 014 12zm8-10C6.477 2 2 6.477 2 12a9.967 9.967 0 00.96 4.281v4.758H7.72A9.965 9.965 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm-1.979 5.526l.909.908a1 1 0 010 1.415l-.611.61s-.086.794.797 1.678c.884.883 2.03 1.151 2.03 1.151l.612-.611a1 1 0 011.414 0l.909.908c.213.214.43.48.246.72-.096.123-.24.287-.457.503-.925.925-1.325.988-1.325.988s-2.316.969-5.01-1.725c-2.693-2.694-1.725-5.01-1.725-5.01s.063-.399.989-1.324a5.5 5.5 0 01.504-.457c.239-.185.505.033.718.246z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$2 = /*#__PURE__*/React__namespace.forwardRef(SvgWhatsapp);

  function SvgWifi(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.248 8.23v.001a.928.928 0 001.307.046 12.777 12.777 0 018.746-3.428c3.269 0 6.374 1.218 8.745 3.428a.926.926 0 001.307-.046h.001a.927.927 0 00-.047-1.307A14.622 14.622 0 0012.3 3 14.627 14.627 0 002.294 6.923a.926.926 0 00-.046 1.308zm10.053-3.68a13.077 13.077 0 010 0zM12.3 8.586c2.427 0 4.705.942 6.417 2.652a.919.919 0 00.654.272c.246 0 .48-.096.654-.271a.919.919 0 00.271-.654.919.919 0 00-.27-.654A10.854 10.854 0 0012.3 6.737c-2.92 0-5.665 1.135-7.725 3.195a.92.92 0 000 1.308.92.92 0 001.308 0A9.014 9.014 0 0112.3 8.587zm0-.3a9.314 9.314 0 00-6.63 2.741.62.62 0 01-.883 0 .626.626 0 01.883 0 9.315 9.315 0 016.63-2.74zm-.003 3.748c1.505 0 2.918.584 3.978 1.644a.624.624 0 100 0 5.588 5.588 0 00-3.978-1.644 5.59 5.59 0 00-3.977 1.644l.212.213a.92.92 0 01-1.308-.001.92.92 0 010-1.308l.213.213-.213-.213a7.127 7.127 0 015.073-2.097 7.13 7.13 0 015.074 2.098.92.92 0 01-.001 1.308.924.924 0 01-1.307 0 5.288 5.288 0 00-3.766-1.557 5.29 5.29 0 00-3.765 1.556l-.212-.212a5.59 5.59 0 013.977-1.644zm5.044 1.171l.001.032m-8.467 4.42a3.429 3.429 0 003.425 3.424 3.429 3.429 0 003.425-3.425 3.429 3.429 0 00-3.425-3.425 3.429 3.429 0 00-3.425 3.425z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef$1 = /*#__PURE__*/React__namespace.forwardRef(SvgWifi);

  function SvgXRay(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 5H5v14h14V5zM5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H5zm6 4.107V6h2v1.107c.977.195 1.961.624 2.71 1a19.295 19.295 0 011.806 1.035l.03.02.008.006.003.002h.001L17 10l-.558.83-.005-.004-.02-.013-.089-.058a17.318 17.318 0 00-1.515-.862c-.604-.302-1.237-.57-1.813-.73v1.944c.977.195 1.961.623 2.71 1a19.274 19.274 0 011.806 1.035l.03.02.008.006.003.002h.001L17 14l-.558.83-.005-.004-.02-.013-.089-.058a17.333 17.333 0 00-1.515-.862c-.604-.302-1.237-.57-1.813-.73v1.928c.617.112 1.15.31 1.562.503a6.642 6.642 0 01.956.546l.062.045.02.015.007.005.002.002h.001v.001L15 17l-.611.792h.001l-.026-.018a4.639 4.639 0 00-.647-.367C13.265 17.196 12.662 17 12 17c-.662 0-1.265.196-1.717.407a4.635 4.635 0 00-.647.367l-.026.018h.001L9 17a151.87 151.87 0 01-.61-.792v-.001l.003-.002.007-.005.02-.015.062-.045A6.64 6.64 0 0111 15.091v-1.929c-.576.162-1.21.429-1.813.732a17.354 17.354 0 00-1.603.919l-.021.013-.004.003a431.448 431.448 0 00-1.117-1.659l.004-.002.008-.006.03-.02a11.524 11.524 0 01.494-.31c.327-.198.785-.461 1.312-.726.748-.376 1.733-.804 2.71-.999V9.162c-.576.162-1.21.429-1.813.732a17.338 17.338 0 00-1.603.919l-.021.013-.004.003L7 10l-.558-.83.004-.002.008-.006.03-.02.107-.07a19.332 19.332 0 011.699-.966c.748-.375 1.733-.804 2.71-.999zM9.61 17.792l-.002.002.002-.002zm4.78 0l.003.003-.001-.001-.002-.001z",
      fill: "currentcolor"
    }));
  }

  var ForwardRef = /*#__PURE__*/React__namespace.forwardRef(SvgXRay);
  exports.Add = ForwardRef$1M;
  exports.AgConsulta = ForwardRef$1L;
  exports.AgExams = ForwardRef$1K;
  exports.App = ForwardRef$1J;
  exports.ArrowCornerRight = ForwardRef$1I;
  exports.ArrowDown = ForwardRef$1H;
  exports.ArrowLeft = ForwardRef$1G;
  exports.ArrowRight = ForwardRef$1F;
  exports.ArrowUp = ForwardRef$1E;
  exports.Attachment = ForwardRef$1D;
  exports.Avatar = ForwardRef$1C;
  exports.Browser = ForwardRef$1B;
  exports.Cake = ForwardRef$1A;
  exports.Calendar = ForwardRef$1z;
  exports.Camera = ForwardRef$1y;
  exports.CameraOff = ForwardRef$1x;
  exports.CameraOn = ForwardRef$1w;
  exports.CameraSwitch = ForwardRef$1v;
  exports.Car = ForwardRef$1u;
  exports.Check = ForwardRef$1t;
  exports.CheckRound = ForwardRef$1s;
  exports.CheckboxEmpty = ForwardRef$1r;
  exports.CheckboxIndeterminate = ForwardRef$1q;
  exports.CheckboxSelected = ForwardRef$1p;
  exports.ChevronDown = ForwardRef$1o;
  exports.ChevronDownSm = ForwardRef$1n;
  exports.ChevronLeft = ForwardRef$1m;
  exports.ChevronLeftSm = ForwardRef$1l;
  exports.ChevronRight = ForwardRef$1k;
  exports.ChevronRightSm = ForwardRef$1j;
  exports.ChevronUp = ForwardRef$1i;
  exports.ChevronUpSm = ForwardRef$1h;
  exports.Clinic = ForwardRef$1g;
  exports.Clock = ForwardRef$1f;
  exports.Close = ForwardRef$1e;
  exports.CloseRound = ForwardRef$1d;
  exports.Cross = ForwardRef$1c;
  exports.Dash = ForwardRef$1b;
  exports.Doctor = ForwardRef$1a;
  exports.Download = ForwardRef$19;
  exports.DownloadExam = ForwardRef$18;
  exports.Edit = ForwardRef$17;
  exports.Evolution = ForwardRef$16;
  exports.ExameImagem = ForwardRef$15;
  exports.Exams = ForwardRef$14;
  exports.Exit = ForwardRef$13;
  exports.Expand = ForwardRef$12;
  exports.Family = ForwardRef$11;
  exports.FavoriteEmpty = ForwardRef$10;
  exports.FavoriteFilled = ForwardRef$$;
  exports.Filter = ForwardRef$_;
  exports.Fold = ForwardRef$Z;
  exports.Fullscreen = ForwardRef$Y;
  exports.FullscreenExit = ForwardRef$X;
  exports.GenderFemale = ForwardRef$W;
  exports.GenderMale = ForwardRef$V;
  exports.Glasses = ForwardRef$U;
  exports.GridCol = ForwardRef$T;
  exports.GridRow = ForwardRef$S;
  exports.Hamburger = ForwardRef$R;
  exports.Handshake = ForwardRef$Q;
  exports.HealthInsurance = ForwardRef$P;
  exports.Heartbeat = ForwardRef$O;
  exports.Home = ForwardRef$N;
  exports.HomeCollection = ForwardRef$M;
  exports.Hospital = ForwardRef$L;
  exports.Id = ForwardRef$K;
  exports.InfoRound = ForwardRef$J;
  exports.Lab = ForwardRef$I;
  exports.Link = ForwardRef$H;
  exports.List = ForwardRef$G;
  exports.Loading = ForwardRef$F;
  exports.Lock = ForwardRef$E;
  exports.Mail = ForwardRef$D;
  exports.MedicalCalendar = ForwardRef$C;
  exports.Menu = ForwardRef$B;
  exports.Message = ForwardRef$A;
  exports.MicOff = ForwardRef$z;
  exports.MicOn = ForwardRef$y;
  exports.Notification = ForwardRef$x;
  exports.Pdf = ForwardRef$w;
  exports.Phone = ForwardRef$v;
  exports.PictureInPicture = ForwardRef$u;
  exports.Pin = ForwardRef$t;
  exports.PortraitFrame = ForwardRef$s;
  exports.Print = ForwardRef$r;
  exports.Question = ForwardRef$q;
  exports.RadioOff = ForwardRef$p;
  exports.RadioOn = ForwardRef$o;
  exports.Refresh = ForwardRef$n;
  exports.Remove = ForwardRef$m;
  exports.RemoveRound = ForwardRef$l;
  exports.Search = ForwardRef$k;
  exports.Security = ForwardRef$j;
  exports.Settings = ForwardRef$i;
  exports.Share = ForwardRef$h;
  exports.Stethoscope = ForwardRef$g;
  exports.Sun = ForwardRef$f;
  exports.Swap = ForwardRef$e;
  exports.Telemedicine = ForwardRef$d;
  exports.Terms = ForwardRef$c;
  exports.TrashBin = ForwardRef$b;
  exports.Tweezer = ForwardRef$a;
  exports.User = ForwardRef$9;
  exports.Vaccines = ForwardRef$8;
  exports.ViewFile = ForwardRef$7;
  exports.ViewOff = ForwardRef$6;
  exports.ViewOn = ForwardRef$5;
  exports.ViewPdf = ForwardRef$4;
  exports.WarningRound = ForwardRef$3;
  exports.Whatsapp = ForwardRef$2;
  exports.Wifi = ForwardRef$1;
  exports.XRay = ForwardRef;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});